module.exports = __webpack_public_path__ + "static/media/royalcurator_logo_full.08985c01.svg";